import React from 'react';
import { Steps } from 'antd';

const STEPS = [
  { title: 'Projeto e Endereços' },
  { title: 'Pagamento e Equipamentos' },
  { title: 'Confirmação' },
];

interface StepperProps {
  current: number;
  onChange: (step: number) => void;
}

export default function Stepper({ current, onChange }: StepperProps) {
  return (
    <div className="mb-6">
      <Steps current={current} onChange={onChange} items={STEPS} />
    </div>
  );
}
